import {
  EfsMelcoEfsModelsEfsDefaultAppSetting,
  ProductionFulfillmentApi,
  useProductionFulfillmentApi,
} from "melco-shared-logic";
import { useCallback } from "react";

const initialValue = {
  defaultSettings: undefined,
};

export type Settings = {
  defaultSettings?: EfsMelcoEfsModelsEfsDefaultAppSetting;
};

export const useDefaultSettings = () => {
  const handleRequest = useCallback(async (api: ProductionFulfillmentApi) => {
    const defaultSettings = await api.productSettingsGetEfsDefaultAppSetting();
    return { defaultSettings };
  }, []);

  return useProductionFulfillmentApi<Settings>({
    initialValue,
    handleRequest,
  });
};
